import React from 'react'
import PropTypes from 'prop-types'

import StarsRating from 'Pods/Shared/StarsRating'

function MessageRating({ rating = null }) {
  return (
    <div className="message__rating">
      <span className="message__rating-title">
        Customer feedback
      </span>
      <span className="message__rating-subtitle">
        Rating:
      </span>
      <span className="message__stars-rate">
        <StarsRating
          rating={rating}
          readonly
        />
      </span>
    </div>
  )
}

MessageRating.propTypes = {
  rating: PropTypes.number,
}

export default MessageRating
